import { useEffect, useRef, useState } from "react";

import { withRouter } from "react-router-dom";

import placeholderImage from "../../../../assets/images/placeholder.jpg";
import { config } from "../../../../config/index";
import { GET, newFetch } from "../../../../helpers/fetch";

import BellIcon from "../../../../assets/icons/bell.png";

const { SERVER_URL } = config;

const HomeNavbar = ({ sidebarToggler, history }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [associate, setAssociate] = useState(null);
  const componentMounted = useRef(true);

  useEffect(() => {
    const fetchUser = async () => {
      let api_path = "/associate/aboutme";
      let response = await newFetch(GET, api_path);

      response.success &&
        componentMounted.current &&
        setAssociate(response.data);
    };
    if (user) {
      fetchUser();
    }
    return () => {
      // This code runs when component is unmounted
      componentMounted.current = false; // set it to false when we leave the page
    };
  }, []);

  return (
    <nav className="navbar portal-navbar align-center d-flex justify-content-between">
      <button
        type="button"
        className="navbar-icon-button"
        onClick={sidebarToggler}
        aria-label="Open navigation menu"
      >
        <i className="fas fa-bars" aria-hidden="true" />
      </button>

      <span className="navbar-text d-flex align-center">
        <button
          type="button"
          onClick={() => history.push("/notifications")}
          className="navbar-icon-button navbar-notification"
          aria-label="View notifications"
        >
          <img
            src={BellIcon}
            alt=""
          />
          <span className="navbar-notification__dot" aria-hidden="true" />
        </button>

        <button
          type="button"
          className="navbar-profile-button"
          onClick={() => history.push("/setting")}
          aria-label="Open account settings"
        >
          <img
            src={
              associate && associate.image
                ? `${SERVER_URL}/${associate.image}`
                : placeholderImage
            }
            alt="default"
            className="rounded-circle border"
            onError={(e) => {
              e.target.onerror = null; // Prevent infinite loop
              e.target.src = placeholderImage;
            }}
          />
        </button>
      </span>
    </nav>
  );
};

export default withRouter(HomeNavbar);
